import React from 'react';

const statusConfig = {
  New: { bg: 'bg-blue-100', text: 'text-blue-800', dot: 'bg-blue-500' },
  Contacted: { bg: 'bg-yellow-100', text: 'text-yellow-800', dot: 'bg-yellow-500' },
  Converted: { bg: 'bg-green-100', text: 'text-green-800', dot: 'bg-green-500' },
  Lost: { bg: 'bg-red-100', text: 'text-red-800', dot: 'bg-red-500' },
};

const StatusBadge = ({ status }) => {
  const config = statusConfig[status] || statusConfig.New;
  
  return (
    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium ${config.bg} ${config.text}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${config.dot}`}></span>
      {status}
    </span>
  );
};

export default StatusBadge;